import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var EdsIdMapperService = /** @class */ (function () {
    function EdsIdMapperService(httpClient) {
        this.httpClient = httpClient;
    }
    EdsIdMapperService.prototype.getByOmapiId = function (omapiId) {
        return this.httpClient.get(this.getCorrectEdsUrl())
            .pipe(map(function (data) {
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                if (item.omapiId === omapiId) {
                    return item;
                }
            }
            return null;
        }));
    };
    EdsIdMapperService.prototype.mapEdsIdsToOmapiIds = function (edsIds) {
        var _this = this;
        return this.httpClient.get(this.getCorrectEdsUrl())
            .pipe(map(function (data) {
            var omapiIds = [];
            for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                var item = data_2[_i];
                if (_this.doesElementContainEdsId(item.edsIds, edsIds)) {
                    omapiIds.push(item.omapiId);
                }
            }
            return omapiIds;
        }));
    };
    EdsIdMapperService.prototype.doesElementContainEdsId = function (items, edsIds) {
        for (var _i = 0, edsIds_1 = edsIds; _i < edsIds_1.length; _i++) {
            var id = edsIds_1[_i];
            if (items.includes(id)) {
                return true;
            }
        }
        return false;
    };
    EdsIdMapperService.prototype.getCorrectEdsUrl = function () {
        if (OmapiIdsUtils.isLegacyUser()) {
            return EdsIdMapperService.omapiEdsLegacyUrl;
        }
        else {
            return EdsIdMapperService.omapiEdsDwnUrl;
        }
    };
    EdsIdMapperService.omapiEdsLegacyUrl = '/assets/omapi/omapi-eds-legacy.json';
    EdsIdMapperService.omapiEdsDwnUrl = '/assets/omapi/omapi-eds-dwn.json';
    return EdsIdMapperService;
}());
export { EdsIdMapperService };
